import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ showText = true, className = "", textColor = "text-safety-yellow" }) => {
  return (
    <Link to="/" className={`flex items-center gap-1.5 sm:gap-2 flex-shrink-0 min-w-0 ${className}`} dir="ltr">
      {/* Logo Box with L */}
      <div className="bg-safety-yellow w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded flex-shrink-0">
        <span className="text-charcoal-grey text-xl sm:text-2xl font-bold">L</span>
      </div>
      {/* LODER Text — hidden on small phones to keep language button fully visible */}
      {showText && (
        <span className={`hidden sm:inline text-3xl font-black ${textColor}`}>LODER</span>
      )}
    </Link>
  );
};

export default Logo;
